module.exports = __webpack_public_path__ + "media/images/icon__settings@2x-5c8c37b590085941e3f8adb46d92f9f2.png";